import { RouterManager } from '@aclass/admin/managers';
import { ExceptionStory } from '@aclass/admin/storage/actions';
import { IAdminState, IExceptionModuleState } from '@aclass/admin/storage/states';
import { BaseResolver } from '@aclass/core/resolvers/base.resolver';
import { NgRedux } from '@angular-redux/store';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable()
export class ExceptionEditStateResolver extends BaseResolver {

    static STOP_EVENT_NAME = 'stop:exception-edit';

    private id: IExceptionModuleState['editPageRecordId'];

    constructor(
        private ngRdx: NgRedux<IAdminState>,
        private routerManager: RouterManager
    ) {
        super();
        this.resolver = this.ngRdx.select<IExceptionModuleState['editPageRecordId']>(['exceptionModule', 'editPageRecordId']).pipe(
            filter(v => v === this.id)
        );
        this.employee = this.routerManager.onRejectNavigation(ExceptionEditStateResolver.STOP_EVENT_NAME);
    }

    /**
     * @inheritDoc
     */
    beforeResolve(route: ActivatedRouteSnapshot): void {
        const id = parseInt(route.params.id);
        this.id = id;
        this.ngRdx.dispatch(ExceptionStory.dryRunEditPage(id));
    }
}
